import { DeleteModalService } from './../services/delete-modal.service';
import { MasterService } from './../services/master.service';
import { PurchaseorderModalComponent } from './../../shared/purchaseorder-modal/purchaseorder-modal.component';
import { StockService } from './../services/stocks.service';
import { Component, OnInit, Input, Output, EventEmitter, Injectable   } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaginationInstance } from 'ngx-pagination';
import {CommonAlertService} from '../../services/common-alert.service';
// @ts-ignore
import {CALLBACK_URL} from '../../config/sage';

@Component({
  selector: 'app-purchaseorder',
  templateUrl: './purchaseorder.component.html',
  styleUrls: ['./purchaseorder.component.scss']
})
export class PurchaseorderComponent implements OnInit {

  public purchaseorder: any;
  public filter: any;
  public totalCount: number;
  public currentPage: number;
  public perPage: number;
  public stockPageId = 'stockPageId';
  public pageEvent: PageEvent;
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  public placeHolder: any = 'Search By PO No';
  public searchByStatus: any = 'New';
  public viewPermission = false;
  public addPermission = false;
  public editPermission = false;
  public deletePermission = false;
  public approvalPermission = false;
  public CALLBACK_URL = CALLBACK_URL.URL;
  public CALLBACK_CLIENT_ID = CALLBACK_URL.CLIENT_ID;
  bool = false;
  paginationID = 'listing_pagination';
  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  // tslint:disable-next-line:max-line-length
  constructor(public stockservice: StockService, public dialog: MatDialog, public masterService: MasterService, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService) { }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = this.addPermission = this.editPermission = this.deletePermission = this.approvalPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['purchase_order.view'] == 1 || roles['purchase_order.add'] == 1 || roles['purchase_order.edit'] == 1 || roles['purchase_order.delete'] == 1  || roles['purchase_order.approval'] == 1) {
        this.viewPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['purchase_order.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['purchase_order.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['purchase_order.delete'] == 1) {
        this.deletePermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['purchase_order.approval'] == 1) {
        this.approvalPermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token'),
      searchType: this.searchByStatus
    };

    this.getPurchaseOrderData();
  }

  getPurchaseOrderData() {
      this.masterService.getIndex('/purchase_orders/index', this.filter).subscribe(res => {
        // @ts-ignore
        this.purchaseorder = res.data.items;
        // @ts-ignore
        this.totalCount = res.data.total;
      // @ts-ignore
        this.currentPage = res.data.current_page;
      // @ts-ignore
        this.perPage = res.data.per_page;
        this.bool = true;
        const newData = {
        id: '',
        po_date: '',
        warehouse_id: '',
        location_id: ''
      };

      // @ts-ignore

        if (this.purchaseorder.length < 10) {
        for ( let i = this.purchaseorder.length; i < 9 ; i++) {
        // for ( let i = 0; i < 9 ; i++) {
          this.purchaseorder.push(newData);
        }
      }

      // @ts-ignore
        if (res.data.total == 0) {
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'});
      }

    });
  }

  getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By SO No';
          break;
        case '1':
          this.placeHolder = 'Search By SO Date';
          break;
        case '2':
          this.placeHolder = 'Search by Status';
          break;
        case '3':
          this.placeHolder = 'Search by City Name';
          break;
          default: this.placeHolder = 'Search By SO No';
      }
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(PurchaseorderModalComponent, {
      minWidth: '90vw',
      disableClose: true,
      data: {
      }
    }).afterClosed().subscribe(() => this.getPurchaseOrderData());
  }

  editDialog(index) {
    const editId = this.purchaseorder[index].id;
    const encID = this.purchaseorder[index].enc_id;
    // tslint:disable-next-line:triple-equals
    if ( editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(PurchaseorderModalComponent, {
        minWidth: '90vw',
        disableClose: true,
        data: {
            id: editId,
            enc_Id: encID
        }
      }).afterClosed().subscribe(() => this.getPurchaseOrderData());
    }
  }


  editTable(id, e) {
    // console.log(e, 'see');
  }


  doSearch(): void {
  if (this.searchBy != null) {
    switch (this.searchBy) {
         case 0:
           Object.assign(this.filter, {search: { type: 'int', field: 'purchase_orders.id', text: this.searchTxt}});
           break;
        case 1:
          Object.assign(this.filter, {search: { type: 'str', field: 'purchase_orders.po_date', text: this.searchTxt}});
          break;
        default:
          Object.assign(this.filter, {search: { type: 'int', field: 'purchase_orders.id', text: this.searchTxt}});
      }
    }
  Object.assign(this.filter, {searchType: this.searchByStatus });
  this.getPurchaseOrderData();
  }

   doRefresh(): void {

     this.searchTxt = null;
     this.filter = {
      token: localStorage.getItem('token'),
      searchType: this.searchByStatus
    };

     this.getPurchaseOrderData();
  }


  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getPurchaseOrderData();
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  // Delete the purchase order
  deleteDialog(i): void {
    this.deleteModalService.openModal({
      id: this.purchaseorder[i].id,
      encId: this.purchaseorder[i].enc_id,
      token: localStorage.getItem('token'),
      deleteUrl: '/purchase_orders/destroy'
    });

    this.deleteModalService.closed.subscribe(() => {
      this.getPurchaseOrderData();
    });
  }
  sage_invoice() {
    // tslint:disable-next-line:max-line-length
    window.open('https://www.sageone.com/oauth2/auth/central?response_type=code&client_id=' + this.CALLBACK_CLIENT_ID + '&redirect_uri=' + this.CALLBACK_URL + ' &scope=full_access', 'popup', 'width=600,height=600');
    return false;
  }
}
